/* eslint no-param-reassign: "error" */

export default {
  SET_ALL_BUSINESS_UNITS(state, data) {
    state.businessUnits = data;
  },

  ADD_NEW_BUSINESS_UNIT(state, data) {
    state.businessUnits.push(data);
  },

  UPDATE_BUSINESS_UNIT(state, updatedBusinessUnit) {
    const index = state.businessUnits.findIndex(
      (unit) => unit.idInDB === updatedBusinessUnit.idInDB
    );
    if (index !== -1) {
      state.businessUnits.splice(index, 1, updatedBusinessUnit);
    }
  },
};
